import React from 'react';

import QuotesContextProvider from '@/common/contexts/QuotesContext/QuotesContext';

import {
  QuotesLayoutDefaultProps,
  QuotesLayoutPropTypes,
} from './QuotesLayout.proptypes';

const QuotesLayout = ({ children }) => (
  <QuotesContextProvider>{children}</QuotesContextProvider>
);

QuotesLayout.defaultProps = {
  ...QuotesLayoutDefaultProps,
};

QuotesLayout.propTypes = {
  ...QuotesLayoutPropTypes,
};

export default QuotesLayout;
